"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sentry_exports = {};
__export(sentry_exports, {
  SentryAnalyticProvider: () => SentryAnalyticProvider
});
module.exports = __toCommonJS(sentry_exports);
var Sentry = __toESM(require("@sentry/svelte"));
class SentryAnalyticProvider {
  static {
    __name(this, "SentryAnalyticProvider");
  }
  navigate(path) {
  }
  init(config) {
    if (config.SENTRY_DSN !== void 0 && config.SENTRY_DSN !== "") {
      Sentry.init({
        dsn: config.SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false
          })
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1,
        tracePropagationTargets: [/^https:\/\/huly\.app/, /^https:\/\/app\.huly\.io/, /^https:\/\/account\.huly\.io/],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1
      });
      return true;
    }
    return false;
  }
  setUser(email) {
    Sentry.setUser({ email });
  }
  setAlias(distinctId, alias) {
  }
  logout() {
    Sentry.setUser(null);
  }
  setTag(key, value) {
    Sentry.setTag(key, value);
  }
  setWorkspace(ws, guest) {
    const prop = guest ? "visited-workspace" : "workspace";
    this.setTag(prop, ws);
  }
  handleEvent(event) {
  }
  handleError(error) {
    Sentry.captureException(error);
  }
}
//# sourceMappingURL=sentry.js.map
